export const environment = {
  apiHttp: 'https://',
  apiWs: 'wss://',
  apiUrl: 'mesitisai-back-dev.fromscratch-apis.com',
  accessToken: '5DSy6T3Bl4cb7b1b',
  debug: true,
  sentryEnvironment: 'dev',
  sentryDsn:
    'https://c748bc8c2204a5a84b22563bfd8acc28@o4504695068164096.ingest.us.sentry.io/4511110031933440',
  formsparkFallbackEnabled: false,
  formsparkId: '',
};
